import { render, staticRenderFns } from "./PluginCcm19.vue?vue&type=template&id=4835d817"
import script from "./PluginCcm19.vue?vue&type=script&lang=js"
export * from "./PluginCcm19.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4835d817')) {
      api.createRecord('4835d817', component.options)
    } else {
      api.reload('4835d817', component.options)
    }
    module.hot.accept("./PluginCcm19.vue?vue&type=template&id=4835d817", function () {
      api.rerender('4835d817', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/plugins/PluginCcm19.vue"
export default component.exports